import { BleClient } from "@capacitor-community/bluetooth-le";

export const disconnectDevice = (deviceId: string) => {
  return BleClient.disconnect(deviceId);
};
